import Navbar  from "../../../NavBar/NavBar.js";
import Footer from "../../../Home/Footer.js"
import Whatsapp from "../../../Home/Whatsapp.js";
import Spinner from "../../../Home/Spinner.js";
import { useEffect } from "react";
import SectionUs3 from "./page_us/Solution-US-3/SectionUs3.js";




const PlafondsMursTendus = () => {
  useEffect(() => {
  // ========= TITLE =========
  document.title =
    "Papier Peint Maroc | Revêtement Mural Design & Impression HD – UNIK SYSTEM";

  // ========= FUNCTIONS =========
  const setMeta = (name, content) => {
    let tag = document.querySelector(`meta[name='${name}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", name);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  const setMetaProperty = (property, content) => {
    let tag = document.querySelector(`meta[property='${property}']`);
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("property", property);
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", content);
  };

  // ========= BASIC SEO =========
  setMeta(
    "description",
    "Papier peint au Maroc avec UNIK SYSTEM : revêtement mural design, impression HD et décoration moderne pour salon, chambre et bureau. Devis gratuit."
  );

  setMeta(
    "keywords",
    "papier peint maroc, papier peint casablanca, papier peint mural maroc, revetement mural maroc, papier peint design maroc, papier peint 3D maroc, papier peint panoramique maroc, UNIK SYSTEM papier peint"
  );

  setMeta("robots", "index, follow");

  // ========= CANONICAL =========
  let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }
  canonical.setAttribute("href", "https://unik-system.com/papier-peint-maroc");

  // ========= OPEN GRAPH =========
  setMetaProperty("og:title", "Papier Peint Maroc – UNIK SYSTEM");
  setMetaProperty(
    "og:description",
    "Revêtement mural design et impression HD pour décoration intérieure au Maroc."
  );
  setMetaProperty(
    "og:image",
    "https://unik-system.com/static/media/SLIDE-US-VINYL.f5cc2ef6d916a31bf099.webp"
  );
  setMetaProperty(
    "og:url",
    "https://unik-system.com/papier-peint-maroc"
  );
  setMetaProperty("og:type", "website");

  // ========= TWITTER =========
  setMeta("twitter:card", "summary_large_image");
  setMeta("twitter:title", "Papier Peint Maroc – UNIK SYSTEM");
  setMeta(
    "twitter:description",
    "Papier peint design et impression murale HD au Maroc."
  );
  setMeta(
    "twitter:image",
    "https://unik-system.com/static/media/SLIDE-US-VINYL.f5cc2ef6d916a31bf099.webp"
  );

  // ========= SCHEMA JSON-LD (SERVICE) =========
  const schema = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Papier Peint Maroc",
    description:
      "Revêtement mural design et impression HD au Maroc pour maison, bureau et commerces.",
    provider: {
      "@type": "Organization",
      name: "UNIK SYSTEM",
      url: "https://unik-system.com",
    },
    areaServed: {
      "@type": "Country",
      name: "Morocco",
    },
    serviceType: "Décoration murale",
    url: "https://unik-system.com/papier-peint-maroc",
  };

  let script = document.querySelector("#schema-us-print");
  if (!script) {
    script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "schema-us-print";
    document.head.appendChild(script);
  }
  script.innerHTML = JSON.stringify(schema);

}, []);



  
    return(
        <div className="body">
            <Spinner/>
            <Navbar/>
            <Whatsapp/>
            <SectionUs3/>
            <Footer/>
        </div>    
    )
};

export default PlafondsMursTendus;